<template>
  <v-container fluid class="pa-0">
    <div class="wrapper">
      <div class="header_wrapper">
        <v-toolbar color="primary" dark>
          <v-btn @click="routerBack" style="position: absolute" icon>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-toolbar-title
            style="position:absolute; left:50%; transform:translateX(-50%); margin:0;"
          >
             {{
               createYearMonth({
                 year: selectedInvoice.year,
                 month: selectedInvoice.month,
               })
             }}
           </v-toolbar-title>
        </v-toolbar>
      </div>

      <v-card class="mt-1" variant="flat">
        <v-table density="compact" class="invoice-table" style="margin-top: 8px;">
          <thead>
            <tr>
              <th class="text-left">項目</th>
              <th class="text-left">金額</th>
              <th class="text-left">課税/非課税</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>月極保育料</td>
              <td>
                &yen;{{ selectedInvoice.monthlyNurseryFee + selectedInvoice.monthlyNurseryFeeDiff }}
              </td>
              <td>{{ getIsFeeStr(selectedInvoice.hasMonthlyFeeTax) }}</td>
            </tr>
            <tr>
              <td>一時保育料</td>
              <td>
                &yen;{{ selectedInvoice.tempNurseryFee + selectedInvoice.tempNurseryFeeDiff }}
              </td>
              <td></td>
            </tr>
            <tr>
              <td>月極延長保育料</td>
              <td>
                &yen;{{ selectedInvoice.monthlyAdditionalFee + selectedInvoice.monthlyAdditionalFeeDiff }}
              </td>
              <td>
                {{ getIsFeeStr(selectedInvoice.hasMonthlyAdditionalTax) }}
              </td>
            </tr>
            <tr>
              <td>スポット延長保育料</td>
              <td>
                &yen;{{ selectedInvoice.spotAdditionalFee + selectedInvoice.spotAdditionalFeeDiff }}
              </td>
              <td>
                {{ getIsFeeStr(selectedInvoice.hasSpotAdditionalFeeTax) }}
              </td>
            </tr>
            <tr v-for="a in selectedInvoice.addtionalFeeDetails" :key="a.date">
              <td class="ps-6 text-grey-darken-1">{{ getDateStr(a.date) }} {{ a.durationMin }}分</td>
              <td>{{ a.fee }}</td>
              <td></td>
            </tr>
            <tr v-if="hasSpotMaximumLimit">
              <td colspan="3" class="text-caption text-error pa-2" style="white-space: normal;">
                ※ 表示されている各日のスポット延長料金の合計は上限設定額を上回ることがあります。実際のご請求は、設定された上限金額となります。
              </td>
            </tr>
            <tr>
              <td>主食・副食料</td>
              <td>
                &yen;{{ selectedInvoice.foodServiceFee + selectedInvoice.foodServiceFeeDiff }}
              </td>
              <td>{{ getIsFeeStr(selectedInvoice.hasFoodServiceFeeTax) }}</td>
            </tr>
            <tr>
              <td>先月以前請求額</td>
              <td>&yen;{{ selectedInvoice.accountsReceivable }}</td>
              <td></td>
            </tr>
          </tbody>
        </v-table>
      </v-card>

      <v-card class="mt-1" variant="flat">
        <v-table density="compact">
          <thead>
            <tr>
              <th class="text-left">その他</th>
              <th class="text-right">
                ({{ getIsFeeStr(selectedInvoice.hasExtraServiceFeeTax) }})
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="e in selectedInvoice.extraServiceDetails" :key="e.uniqueServiceId">
              <td>{{ e.serviceName }}</td>
              <td class="text-right">{{ e.adjustmentAmount + e.fee }}</td>
            </tr>
          </tbody>
        </v-table>
      </v-card>

      <v-card class="mt-2" variant="flat" border>
        <v-table density="compact">
          <thead>
            <tr>
              <!-- <th class="text-left"></th>
              <th class="text-left"></th> -->
              <th class="text-right">合計金額</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <!-- <td class="font-weight-bold"></td>
              <td class="font-weight-bold"></td> -->
              <td class="text-right font-weight-bold text-h6 py-2">
                {{ selectedInvoice.totalAmount }}円
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-card>

      <div class="mt-5 mx-4">
        <p class="mb-3">上記の通りご請求申し上げます。</p>

        <div v-if="!isGakken(selectedInvoice.transferAccount?.nurseryId)" class="pb-10">
          <p class="text-caption mb-1">
            お支払い方法：{{ getPaymentCategoryStr(selectedInvoice.paymentMethod) }}
          </p>

          <div v-if="!selectedInvoice.paymentMethod || selectedInvoice.paymentMethod === 'invoice'">
            <p class="text-caption text-grey-darken-1">
              ※前月ご請求額のご入金状況につきましては{{ selectedInvoice.month }}月25日までのご入金までを反映しています。
            </p>
            <p class="my-3 text-body-2 font-weight-bold">
              【{{ calcMonth(selectedInvoice.month) }}月25日】までにお子様のお名前で、下記口座へお振込をお願い致します。
            </p>
            
            <v-sheet rounded class="pa-4" style="border: 3px solid rgba(0, 0, 0, 0.50);">
              <p class="text-caption font-weight-bold mb-2">お振込先</p>
              <div class="text-body-1">
                <p>{{ selectedInvoice.transferAccount.beneficiaryBank }} {{ selectedInvoice.transferAccount.branchName }}</p>
                <p>口座番号：{{ selectedInvoice.transferAccount.accountNumber }}</p>
                <p>名義：{{ selectedInvoice.transferAccount.accountHolder }}</p>
              </div>
            </v-sheet>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');

import { meModule } from '@/store/entityModules/me';
import { familyModule } from '@/store/entityModules/family';
import { invoiceModule } from '@/store/entityModules/invoice';
import { forceAppRerender } from '@/utils/appRerender';

interface DataType {
  childId: number;
  childName: string;
  fetchLoading: boolean;
}

export default defineComponent({
  computed: {
    selectedChildImg() {
console.log('a');
console.log(this.childId);
if (familyModule.family) {
console.log('b');
console.log(this.childId);
const children = familyModule.family.children;
const child = children.find((c) => c.childId === this.childId);
if (!!child) {
          return child.imageUrl;
        }
      }
return null;
    },
    selectedInvoice() {
      return invoiceModule.selectedInvoice;
    },
    selectedChildId() {
      return invoiceModule.selectedChildId;
    },
    extraItems() {
      if (invoiceModule.selectedInvoice) {
        const keys = Object.keys(
          invoiceModule.selectedInvoice.extraServiceDetails,
        );
        return keys;
      }
      return [];
    },
    hasSpotMaximumLimit(): boolean {
      const invoice = invoiceModule.selectedInvoice;
      if (!invoice || !invoice.addtionalFeeDetails) {
        return false;
      }
      // 明細の合計金額を計算
      const detailTotal = invoice.addtionalFeeDetails.reduce(
        (sum: number, detail: { fee: number }) => sum + detail.fee,
        0,
      );
      // スポット延長料金（請求額）
      const spotFee = invoice.spotAdditionalFee + invoice.spotAdditionalFeeDiff;
      // 明細合計 > 請求額 かつ 請求額 > 0 の場合に上限適用とみなす
      return detailTotal > spotFee && spotFee > 0;
    },
  },

  data: (): DataType => ({
    childId: NaN,
    childName: '',
    fetchLoading: false,
  }),

  methods: {
    routerBack() {
      this.$router.back();
    },
    getDateStr(date: string) {
      return dayjs(date).format('YYYY/MM/DD');
    },
    createYearMonth({ year, month }: { year: number; month: number }) {
      if (month < 4) {
        return `${year + 1}年${month}月`;
      } else {
        return `${year}年${month}月`;
      }
    },
    calcMonth(selectedMonth: number) {
      const month = selectedMonth + 1;
      if (month > 12) {
        return 1;
      } else {
        return month;
      }
    },
    getIsFeeStr(isFee: boolean | null) {
      if (isFee === null) {
        return '';
      } else if (isFee) {
        return '課税';
      } else {
        return '非課税';
      }
    },
    getPaymentCategoryStr(category: string) {
      switch (category) {
        case 'card':
          return 'クレジットカード';
          break;

        case 'withdrawal':
          return '口座引き落とし';
          break;

        case 'invoice':
          return '振り込み';
          break;

        default:
          break;
      }
    },
    isGakken(nurseryId: number | null | undefined) {
      if (
        // nurseryId === 109999403999 ||
        nurseryId === 272111111351 ||
        nurseryId === 149999227999 ||
        nurseryId === 271111111451 ||
        nurseryId === 293111111451 ||
        nurseryId === 215111111451 ||
        nurseryId === 169999319999 ||
        nurseryId === 238111111441 ||
        nurseryId === 250111111441 ||
        nurseryId === 189999320999 ||
        nurseryId === 109999322999 ||
        nurseryId === 129999324999 ||
        nurseryId === 218111111331
      ) {
        return true;
      }
      return false;
    },
  },

  async mounted() {

    const user = meModule.me;
    if (!invoiceModule.selectedInvoice) {
      this.$router.replace('/invoice/select');
    }
    if (this.selectedChildId && this.selectedInvoice && user && !this.selectedInvoice.readDate) {
      const parentId = Number(user.parentId);
      await invoiceModule.updateInvoiceRead({year:this.selectedInvoice.year, month:this.selectedInvoice.month, childId:this.selectedChildId, userId:parentId, readDate:dayjs().toISOString()});
      // 画面が開かれたときに App.vue の再マウントを指示
      forceAppRerender();
    }
  },
});
</script>
<style lang="scss" scoped>
.wrapper {
  padding-top: calc(var(--app-top-offset) + 56px); // ← ヘッダー分
  margin-bottom: calc(env(safe-area-inset-bottom) + 56px);
}

/* ===== ヘッダー ===== */
.header_wrapper {
  height: 56px;
  width: 100%;
  position: fixed;
  top: var(--app-top-offset); // ← 超重要
  left: 0;
  z-index: 100;

  .outline {
    border: 1px solid rgb(var(--v-theme-primary));
  }
}

/* ===== フォーム余白 ===== */
.v-form {
  margin-top: 8px;
}

/* ===== ラベルサイズ ===== */
.label-size > .v-input__control > .v-input__slot > .v-input--selection-controls__input > label {
  font-size: 12px;
}
.content_wrapper {
  min-height: calc(100% - 56px);
  overflow-y: hidden;
}
.bank-wrapper {
  border: 2px solid #000000;
}

.spot-notice {
  font-size: 12px;
  color: #666;
  padding-top: 8px;
  line-height: 1.4;
}

.spot-detail-indent {
  padding-left: 48px !important;
}
</style>
